import { Permission } from '@act/shared/authorization';
import { ActingUserDto, UserDto } from '@act/shared/data-transfer-objects';
import { checkPermissionOnMember } from 'redux/utils/auth/permissionChecks';

export function shouldSuggestTransferRequest(
  member: UserDto,
  actingUser: ActingUserDto
) {
  return (
    member?.assignedGuideId === actingUser.id ||
    checkPermissionOnMember({
      member,
      actingUser,
      permission: Permission.CAN_AUDIT_MEMBER_TRANSFER_REQUESTS,
    })
  );
}
